import './App.css';
import { AppContainer } from './components/speech-generator/Index';

function App() {
  return <AppContainer />;
}

export default App;
